module.exports = __webpack_public_path__ + "img/gift11.bded44f5.png";